/**
 * Created with IntelliJ IDEA.
 * User: mozartdiniz
 * Date: 10/3/13
 * Time: 3:55 PM
 * To change this template use File | Settings | File Templates.
 */



Monet.Builder = Monet.Builder || {};

Monet.Builder.DataMapper = function () {

    this.entity = null;

    this.setEntity = function (entity) {

        if (entity) {
            this.entity = entity;
        } else {
            var error = new Monet.Exception.ReturnError(
                this, 'Monet.Builder.DataMapper: setEntity: entity is null'
            );
            error.console();
        }
    };

    this.getFieldList = function (callback) {

        var request = new Monet.Ajax ();
        request.url = 'form/' + this.entity + '/Fields';

        if (callback) {
            request.success = (function(callback, scope) {
                return function (data) {
                    if (data.length) {
                        var fields =  scope.parseFieldList (data);
                        App.Forms[scope.entity] = App.Forms[scope.entity] || {};
                        App.Forms[scope.entity].fields = fields;
                        callback (data);
                    }
                };
            }(callback, this));
        }

        request.send();
    };

    this.checkDataMapperNamespace = function () {

        if (!App.Forms[this.entity] || !App.Forms[this.entity].dataMapper) {

            App.Forms[this.entity] = App.Forms[this.entity] || {};
            App.Forms[this.entity].dataMapper = App.Forms[this.entity].dataMapper || {};

            return true;
        }

        return false;

    };

    this.parseFieldList = function (fields) {

        var parsedFields = {},
            fieldList = fields,
            lookupEntityName,
            field,
            parsedMeta = null,
            keys = [],
            sortedParsedFields = {};

        if (typeof fields === 'string') {
            fieldList = JSON.parse(fields);
        }

        if (fieldList) {

            for (var i = 0, j = fieldList.length; i < j; i++) {

                parsedMeta = null;
                field = fieldList[i];
                lookupEntityName = null;

                if (field.lookupEntity) {
                    lookupEntityName = field.lookupEntity.name || field.lookupEntity.key;
                }

                if (field.meta) {
                    try {
                        parsedMeta = (typeof field.meta === 'string')? JSON.parse (field.meta): field.meta;
                    } catch(e) {
                        var error = new Monet.Exception.ReturnError(
                            e, 'Monet.Builder.DataMapper: parseFieldList: cant parse meta from field', e
                        );
                        error.console();
                    }
                }

                parsedFields[field.name] = {
                    id: field.id,
                    name: field.name,
                    label: field.label,
                    translatedLabel: Monet.I18n.getResourcesByKey (field.label),
                    type: field.type,
                    meta: parsedMeta,
                    lookupEntityColumn: field.lookupEntityColumn,
                    lookupEntity: lookupEntityName,
                    mandatory: field.mandatory
                };

            }


            for (var key in parsedFields) {
                var oKeys = {};
                oKeys.key = key;
                oKeys.translatedLabel = parsedFields[key].translatedLabel;

                keys.push (oKeys);
            }

            keys = keys.sort (this.sortTranslatedResources);

            for (var k = 0, l = keys.length; k < l; k++) {

                sortedParsedFields[keys[k].key] = parsedFields[keys[k].key];

            }

            return sortedParsedFields;
        } else {
            var exception = new Monet.Exception.ReturnError(
                this, 'Monet.Builder.DataMapper: parseFieldList: fieldList is null'
            );
            exception.console();
        }

    };

    this.sortTranslatedResources = function (a,b) {

        if (a.translatedLabel.toLowerCase() < b.translatedLabel.toLowerCase()) {
            return -1;
        } else  if (a.translatedLabel.toLowerCase() > b.translatedLabel.toLowerCase()) {
            return 1;
        }

        return 0;

    };

    this.build = function (buildCallback, layout) {

        const needToGetFields = this.checkDataMapperNamespace() && !App.Forms[this.entity].fields;

        if (layout) {
            var pageLayout = new Monet.PageLayout(layout);

            var fields = this.parseFieldList(pageLayout.getFields());
            this.addFieldsToDataMapper(fields);
        }

        if (needToGetFields && this.entity) {

            this.getFieldList((function (scope){
                return function (data) {

                    var fields =  scope.parseFieldList (data);
                    scope.addFieldsToDataMapper(fields);

                    if (buildCallback) {
                        buildCallback (data);
                    }
                };
            }(this)));

        } else {
            if (buildCallback) {
                buildCallback ();
            }
        }

    };

    this.copyDataMapperToAnotherNamespace = function (newEntity) {

        if (newEntity && App.Forms[this.entity]) {

            if (!App.Forms[newEntity]) {

                App.Forms[newEntity] = {};

            }

            var dataMapper = App.Forms[this.entity].dataMapper;
            var fields = App.Forms[this.entity].fields;

            App.Forms[newEntity].dataMapper = (dataMapper ? JSON.parse(JSON.stringify(dataMapper)) : dataMapper);
            App.Forms[newEntity].fields = (fields ? JSON.parse(JSON.stringify(fields)) : fields);

        }
    };

    this.addFieldsToDataMapper = function (fields){
        var entity = this.entity;

        this.checkDataMapperNamespace ();

        for (var key in fields) {

            if(!App.Forms[entity].dataMapper[key]){
                App.Forms[entity].dataMapper[key] = fields[key];
            }
        }
    };

};